import { type Organization } from '@libraries/typescript/api_client/schema_types';

export function posthogCoreAccountTagProperties(
    organization: Pick<Organization, 'core_account_tags'>,
): Record<string, unknown> {
    if (
        organization.core_account_tags === null ||
        organization.core_account_tags === undefined
    ) {
        return {};
    }

    return {
        core_account_tags: organization.core_account_tags,
    };
}

export function posthogOrganizationProperties(
    organization: Organization,
): Record<string, unknown> {
    const trimmedInternalName = organization.internal_name?.trim();

    return {
        name: trimmedInternalName
            ? `${organization.name} - ${trimmedInternalName}`
            : organization.name,
        internal_name: organization.internal_name,
        ...posthogCoreAccountTagProperties(organization),
        customer_lifecycle_stage: organization.customer_lifecycle_stage ?? null,
        training_mode_enabled: organization.training_mode_enabled,
        customer_live_date: organization.customer_live_date ?? null,
        customer_signed_kickoff_date:
            organization.customer_signed_kickoff_date ?? null,
        ...organization.features,
        customer_lifecycle_entry_date:
            organization.customer_churned_date ?? null,
        // Clear the old group property so persisted PostHog profiles do not
        // continue exposing the lifecycle-entry date as customer churn.
        customer_churned_date: null,
    };
}
